



























import { Store } from '@/model/Store';
import { StoreService } from '@/services/StoreService';
import { Inject } from 'vue-typedi';
import {Component, Prop, Vue} from 'vue-property-decorator';
import formatStoreLabel from '@/filters/StoreLabelFormatter';
import formatStoreId from '@/filters/StoreIdFormatter';
import { PageName } from '@/configuration/pages';

@Component({
  filters: {formatStoreLabel, formatStoreId}
})
export default class StoresPanel extends Vue {

    @Prop({}) private store: Store;

    @Inject()
    storeService!: StoreService;

    onSelectStore() {
        this.storeService.updateStoreInSession(this.store, PageName.ORDERS);
    }

    onClickStoreParams() {
        this.$emit("onClickStoreParams", this.store.storeId);
    }

}

